export const productCanyonTiers = ["basic", "start", "scale"] as const
export type ProductCanyonTier = (typeof productCanyonTiers)[number]

export const productCanyonPlans = {
	basic: { label: "Basic", planId: 3, tier: 1, price: 59, aiCredits: 200, commission: 0.1, maxAdmins: 1 },
	start: { label: "Start", planId: 1, tier: 2, price: 199, aiCredits: 600, commission: 0.1, maxAdmins: 3 },
	scale: { label: "Scale", planId: 2, tier: 3, price: 420, aiCredits: 2000, commission: 0.05, maxAdmins: null },
} as const
